import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import ToggleSelectionButtons from './ToggleSelectionButtons'
import ToggleSelectionContents from './ToggleSelectionContents'
import {toggleSelectionTriggered} from "../../actions/Util";
import ReactTooltip from 'react-tooltip'


class ToggleSelection extends Component {

    static propTypes = {
        id: PropTypes.string.isRequired,
        onSelect: PropTypes.func,
        selectionDisabled: PropTypes.bool
    }

    static defaultProps = {
        selectionDisabled: false
    }


    handleButtonClick = (target) => {
        if (this.props.selectionDisabled) {
            return
        }
        if (this.props.activeKey !== target) {
            this.props.toggleSelectionTriggered(target, this.props.activeKey)
        }
    }

    componentDidMount() {
        ReactTooltip.rebuild()
    }

    render() {
        const buttonsInjected = React.Children.map(this.props.children,
            (child) => {
                if (child.type === ToggleSelectionButtons) {
                    return React.cloneElement(child, {
                        onButtonClick: this.handleButtonClick,
                        buttonDisabled: this.props.selectionDisabled,
                        activeKey: this.props.activeKey
                    })
                } else if (child.type === ToggleSelectionContents) {
                    return React.cloneElement(child, {
                        activeKey: this.props.activeKey
                    })
                } else {
                    return child
                }
            }
        )
        return (
            <div className="toggle-selection">
                {buttonsInjected}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        activeKey: state.toggleSelections ? state.toggleSelections[ownProps.id] : ""
    }
}


const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        toggleSelectionTriggered: (contentId, contentIdPrevious) => {
            const oldKey = ownProps.activeKey;
            dispatch(toggleSelectionTriggered(ownProps.id, contentId))
            if (ownProps.onSelect) {
                ownProps.onSelect(contentId, contentIdPrevious)
            }
        }
    }
}

const selection = connect(mapStateToProps, mapDispatchToProps)(ToggleSelection)

export {
    selection as ToggleSelection,
    ToggleSelectionButtons,
    ToggleSelectionContents
}



/** WEBPACK FOOTER **
 ** ./src/containers/util/ToggleSelection.js
 **/